import React, { Component } from 'react'
import PropTypes from 'prop-types'
import '../App.css'
import Header from '../components/Header'
import UserContent from '../components/UserContent'
import { Logger } from "react-remote-logger"
class User extends Component {
  constructor (props) {
    super(props)
    this.state = {
      userGroupId: props.location.state && props.location.state.userGroupId ? props.location.state.userGroupId : null
    }
  }

  componentDidMount() {
    Logger({
      'timestamp': (new Date()).toLocaleString(),
      'level': 'info',
      'user_id': localStorage.user_id,
      'user': localStorage.user_email,
      'organization': localStorage.organization,
      'action': 'GET',
      'url': window.location.href,
      'message': `GET ${window.location.href}`
    })
  }

  render () {
    return (
      <div className='App'>
        <Header
          enabled='user'
          org={this.props.match.params.org}
        />
        <UserContent
          userGroupId={this.state.userGroupId}
          org={this.props.match.params.org}
        />
      </div>
    )
  }
}

User.propTypes = {
  location: PropTypes.object,
  match: PropTypes.object
}

export default User
